// @flow
import React, {Component} from 'react';
import type {ComponentType} from 'react';
import ErrorBoundary from './ErrorBoundary';

export default function withErrorBoundary<Props: {}>(
    WrappedComponent: ComponentType<Props>
): ComponentType<Props> {
    return class WithErrorBoundary extends Component<Props> {
        render() {
            return (
                <ErrorBoundary>
                    <WrappedComponent {...this.props} />
                </ErrorBoundary>
            );
        }
    };
}
